<div class="confirm-code">
  <div class="confirm-code__title">
    <h3>{{ title$ | async | translate }}</h3>
  </div>

  <form
    autocomplete="off"
    [formGroup]="form"
    (submit)="submit()"
  >
    @if (isAuthenticated) {
      <div class="form-group">
        <cx-input-field
          type="password"
          formControlName="oldPassword"
          [label]="'forgotPassword.changePassword.currentPassword' | translate"
          [invalid]="form.get('oldPassword')?.touched && !!form.get('oldPassword')?.errors"
          [isPassword]="true"
        />
      </div>
    }

    <div class="form-group">
      <cx-input-field
        type="password"
        formControlName="newPassword"
        [label]="'forgotPassword.newPassword.password' | translate"
        [invalid]="form.get('newPassword')?.touched && !!form.get('newPassword')?.errors"
        [isPassword]="true"
      />
    </div>

    <div class="form-group">
      <cx-input-field
        type="password"
        formControlName="passwordConfirm"
        [label]="'forgotPassword.newPassword.confirmPassword' | translate"
        [invalid]="form.get('passwordConfirm')?.touched && !!form.get('passwordConfirm')?.errors"
        [isPassword]="true"
      />
    </div>

    <ul class="confirm-code__validations" role="list">
      @for (validation of (validations$ | async); track $index) {
        <li class="d-flex gap-1 align-items-center">
          @if (!validation.isDirty) {
            <span class="validation-icon material-symbols-outlined">check_circle</span>
          }
          @else if (validation.isValid) {
            <span class="validation-icon valid material-symbols-outlined">check_circle</span>
          }
          @else {
            <span class="validation-icon invalid material-symbols-outlined">cancel</span>
          }
          <span class="validation-text">{{ validation.name | translate:{maxLength, minLength} }}</span>
        </li>
      }
    </ul>

    <div class="d-grid">
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || (isLoading$ | async)"
      >
        @if (isLoading$ | async) {
          <local-loader />
        }
        @else {
          {{ 'forgotPassword.newPassword.submit' | translate }}
        }
      </button>
    </div>
  </form>
</div>
